import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { TwoFAService } from '../../_services/twoFA.service';
import { StompService } from 'ng2-stomp-service';
import { Constants } from '../../shared/Helpers/constants';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { IUser2FAConfiguration } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-authentication',
  templateUrl: './app-authentication.component.html'
})
export class AppAuthenticationComponent implements OnInit, OnDestroy {
  @Input() isChangingDeviceSetup: boolean = false;
  @Input() userConfig: IUser2FAConfiguration;
  @Output() qrCodeScanned = new EventEmitter<any>();

  public showLastVerificationCodeToLogin: boolean = false;
  public logoPath: any;
  public isChangingDevice: boolean = false;
  public showVerificationCodeFirst: boolean = false;
  public viewToDisplay: string;
  public QRCode: any;
  public appStoreImage: string = Constants.appStoreImage;
  public googlePlayImage: string = Constants.googlePlayImage;
  public msg: string;
  public removeLogo: boolean = false;

  // socket config
  private wsConf = {
    host: `${environment.idam_api_url}/websocket-able`,
    queue: {}
  }
  private subscription: any;

  constructor(
    public sharedService: SharedService,
    private twoFAService: TwoFAService,
    private _stomp: StompService,
    private route: Router
  ) {
    this.connectToServer();
  }

  ngOnInit() {
    if (this.userConfig && this.userConfig.appAuthenticator && this.userConfig.appAuthenticator.deviceId) {
      this.msg = 'Please confirm the change of the device in the previous bound device or in the recovery email if you have one stored.'
      this.viewToDisplay = 'confirmChange';
      this.isChangingDevice = true;
      this.getQRCode();
    } else if (this.route.url.includes('change-device=')) {
      this.viewToDisplay = 'QRCode';
      this.getQRCode();
    }
    else {
      this.viewToDisplay = 'download';
    }
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        }
        else {
          this.logoPath = Constants.logoPath;
        }
      }
      else {
        this.logoPath = Constants.logoPath;
      }
    }
    else {
      this.logoPath = Constants.logoPath;
    }
  }

  getQRCode() {
    if (this.route.url.includes('setup=change')) {
      this.viewToDisplay = 'confirmChange';
    } else {
      this.showVerificationCodeFirst = true;
      const codeToSend: string | any = localStorage.getItem('code');
      const currentOrganisationId: string | any = this.sharedService.currentOrganisationId.value ? this.sharedService.currentOrganisationId.value : localStorage.getItem('currentOrg');
      const loggedUserId = this.sharedService.loggedUserId.value ? this.sharedService.loggedUserId.value : localStorage.getItem('loggedUser');
      this.twoFAService.getQRCode(currentOrganisationId, loggedUserId, codeToSend).subscribe({
        next: (res) => {
          if (this.route.url.includes('app-authentication?change-device=')) {
            this.viewToDisplay = 'QRCodeForDeviceChange';
          } else {
            this.viewToDisplay = 'QRCode';
          }
          this.QRCode = res.body;
        },
        error: (err) => {
          if (err.status == 403 && JSON.parse(err.error).errorCode == 1002) {
            this.msg = JSON.parse(err.error).detailedMessage;
            this.viewToDisplay = 'confirmChange';
          }
        }
      })
    }
  }

  // Web Socket Configuration
  private connectToServer() {
    this._stomp.configure(this.wsConf);
    this._stomp.startConnect().then(() => {
      this.subscription = this._stomp.subscribe('/topic/person/' + this.sharedService.loggedUserId.value, this.result);
    });
  }

  // Web socket result
  public result = (data) => {
    if (data != undefined) {
      this.qrCodeScanned.emit();
      setTimeout(() => {
        this._stomp.disconnect().then(() => {
        })
      }, 2000);
    }
  }

  ngOnDestroy() {
    this._stomp.disconnect().then(() => {
    })
  }


  public removeLogoFromView(view) {
    this.removeLogo = view
  }

  nextClicked() {
    this.qrCodeScanned.emit();
    localStorage.clear();
    this.isChangingDevice = false;
    this.showLastVerificationCodeToLogin = true;
    this.viewToDisplay = '';
  }
}
